export default function useTerminationReasonHook(currentValues) {
  const terminationLabel = currentValues.terminationReasonObject?.label || '';
  const noticeMonthDisabled = terminationLabel.includes('Art. 160') || terminationLabel.includes('Art. 159');
  return {
    noticeMonthDisabled
  };
}
